<template>
  <div class="menu-item-form">
    <div>
      <vs-input
        class="w-full"
        label="Titulo del menú *"
        v-validate="'required'"
        name="title"
        v-model.lazy="menuItemSelected.text"
        :danger="errors.has('title')"
        :danger-text="errors.first('title')"
      ></vs-input>
    </div>
    <div class="mt-2" v-if="!isRoot">
      <label class="vs-input--label">Menú padre</label>
      <v-select
        :clearable="false"
        v-validate="'required'"
        name="menuParent"
        placeholder="Seleccione"
        label="text"
        class="w-full mt-2"
        v-model.lazy="menuItemSelected.parentMenuItemId"
        :options="menuItems"
        :reduce="item => item.id"
      >
        <div slot="no-options">No hay coincidencias</div>
      </v-select>
    </div>

    <div class="mt-4 mb-2">
      <vs-checkbox v-model="isRoot">Es un elemento raíz</vs-checkbox>
    </div>

    <div>
      <vs-input
        class="w-full mt-2"
        label="Icono"
        name="routeIcon"
        v-model.lazy="menuItemSelected.icon"
      ></vs-input>
      <small>
        <a href="https://fonts.google.com/icons?hl=es-419" target="_blank">
          Revisar la biblioteca de iconos
        </a>
      </small>
    </div>
    <div class="mt-2">
      <label class="vs-input--label">Ruta</label>
      <v-select
        :clearable="false"
        v-validate="'required'"
        name="routeId"
        placeholder="Seleccione"
        label="path"
        class="w-full mt-2"
        v-model.lazy="menuItemSelected.route"
        :options="routes"
      >
        <div slot="no-options">No hay coincidencias</div>
      </v-select>
    </div>

    <div v-if="menuItemSelected !== null" class="mt-2">
      <label>Permisos</label>
      <v-select
        multiple
        label="guard_name"
        v-model="menuItemSelected.route.permissions"
        :options="roles"
        :reduce="role => role.guard_name"
      ></v-select>
    </div>

    <vs-button
      size="small"
      :disabled="errors.count() > 0"
      @click="addItem()"
      class="mt-6">Guardar cambios</vs-button>

    <vs-button
      size="small"
      type="border"
      @click="cancelEdition"
      class="ml-4 mt-6">Cancelar</vs-button>
  </div>
</template>

<script>
import {NavigationService} from "@/models/Menu/NavigationService";

export default {
  name: "MenuItemForm",
  props: ['menuItemSelected', 'roles'],
  data: () => ({
    menuItems: [],
    routes: [],
    isRoot: true
  }),
  async mounted() {
    this.$vs.loading();
    try {
      await this.fillParentMenu()
      const {data} = await axios.get(`/api/backoffice/security/route`)
      this.routes = data;
    } finally {
      this.$vs.loading.close();
    }
  },
  methods: {
    async fillParentMenu() {
      this.$vs.loading();
      try {
        let menu = await NavigationService.find(this.$route.params.menuId);
        this.menuItems = menu.items;
      } finally {
        this.$vs.loading.close();
      }
    },
    async addItem() {
      this.$vs.loading();
      try {
        if (this.isRoot) {
          this.menuItemSelected.parentMenuItemId = null;
        }
        let result = await NavigationService.updateItem(this.menuItemSelected.id, this.menuItemSelected);
        this.$emit("onAddItem", result)
      } finally {
        this.$vs.loading.close();
      }
    },
    cancelEdition() {
      this.$emit('onCancelEdition')
    }
  }
}
</script>

<style scoped>

</style>
